import { render, staticRenderFns } from "./dialog-approval.vue?vue&type=template&id=ab5cb400&scoped=true&"
import script from "./dialog-approval.vue?vue&type=script&lang=js&"
export * from "./dialog-approval.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approval.vue?vue&type=style&index=0&id=ab5cb400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5cb400",
  null
  
)

export default component.exports